var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-xs-center my-4"},[_vm._v("\n  PAGE NOT FOUND\n")])}
var staticRenderFns = []

export { render, staticRenderFns }